var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionsDropdown',{staticClass:"no-hover text-13-400",attrs:{"menu":_vm.actions,"color":"primary","dropdown-icon":"expand_more"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('q-img',{staticClass:"flag",attrs:{"src":_vm.flag}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }